export const RoleNames = Object.freeze({
    INTERVIEWER: 'Interviewer',
    SUPERVISOR: 'Supervisor',
    HQ: 'Headquarter',
    API: 'ApiUser',
    ADMINISTRATOR: 'Administrator',
    OBSERVER: 'Observer',
})